type Props = {
	onClose: () => void;
	projectId: string;
};

export default function ProjectSyncMenuItem(_props: Props) {
	return null;
}
